import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="deal";
export function queryChargeOutDealByAccountId(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryChargeOutDealByAccountId`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function queryForecastDealByAccountId(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryForecastDealByAccountId`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectDealUserForecastProportion() {
  return axios({
    url: `/ws/${moduleName}/selectDealUserForecastProportion`,
    method: 'get',
  })
}

export function getCompanyId() {
  return axios({
    url: `/ws/${moduleName}/getCompanyId`,
    method: 'get',
  })
}


export function selectBeOverdueAll() {
  return axios({
    url: `/ws/${moduleName}/selectBeOverdueAll`,
    method: 'get',
  })
}
export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectStatistic(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectStatistic`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryDealPursuitsByMansionQuery(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryDealPursuitsByMansionQuery`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllByColleagueId(parameter,id) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllByColleagueId/${id}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryDealByColleagueId(parameter,id) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryDealByColleagueId/${id}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryDealPursuitsByCustomerId(parameter,id) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryDealPursuitsByCustomerId/${id}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function queryDealPursuitsByCustomerIdAndType(parameter,id,type) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryDealPursuitsByCustomerIdAndType/${id}/${type}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryDealPursuitsByCustomerOwnerId(parameter,id,type) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryDealPursuitsByCustomerOwnerId/${id}/${type}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function queryByOwnerId(parameter,id) {
  return axios({
    url: `/ws/${moduleName}/queryByOwnerId/${id}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function updateDealDetails(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateDealDetails`,
    method: 'put',
    data:parameter
  })
}

export function batchUpdateEndTime(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/batchUpdateEndTime`,
    method: 'put',
    data:parameter
  })
}


export function updateDealUserForecastProportion(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateDealUserForecastProportion`,
    method: 'put',
    data:parameter
  })
}



// export function updateCurrentLease(parameter){
//   console.log("data:",parameter)
//   return axios({
//     url: `/ws/${moduleName}/updateCurrentLease`,
//     method: 'put',
//     data:parameter
//   })
// }

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export function getDealTeamUser(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/getDealTeamUser/${id}`,
    method: 'get',
  })
}

export function selectMyDeal(year,parameter) {
  console.log("parameter:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectMyDeal/${year}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function insertDealConfirm(parameter){
  return axios({
    url: `/ws/${moduleName}/insertDealConfirm`,
    method: 'post',
    data:parameter
  })
}

export function updateDealConfirm(parameter){
  return axios({
    url: `/ws/${moduleName}/updateDealConfirm`,
    method: 'put',
    data:parameter
  })
}


export function receiveMoney(parameter){
  return axios({
    url: `/ws/${moduleName}/receiveMoney`,
    method: 'post',
    data:parameter
  })
}


export function queryYearTotalNum() {
  return axios({
    url: `/ws/${moduleName}/queryYearTotalNum`,
    method: 'get',
  })
}


export function getLoginUserDeals(parameter) {
  return axios({
    url: `/ws/${moduleName}/getLoginUserDeals`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function saveNewLease(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveNewLease`,
    method: 'post',
    data:parameter
  })
}

export function deleteDeal(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function saveDealClose(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveDealClose`,
    method: 'post',
    data: parameter,
  })
}

export function reopenDeal(id){
  return axios({
    url: `/ws/${moduleName}/reopen/${id}`,
    method: 'put',
  })
}


export function getDealCloseReason(){

  return axios({
    url: `/ws/${moduleName}/getDealCloseReason`,
    method: 'get',
  })
}

export default {
  getCompanyId,
  batchUpdateEndTime,
  selectBeOverdueAll,
  insert,
  selectAll,
  selectOne,
  selectMyDeal,
  updateDealDetails,
  saveNewLease,
  deleteDeal,
  // updateCurrentLease,
  selectAllByColleagueId,
  insertDealConfirm,
  updateDealConfirm,
  queryDealPursuitsByCustomerId,
  queryDealPursuitsByMansionQuery,
  receiveMoney,
  queryYearTotalNum,
  queryByOwnerId,
  saveDealClose,
  reopenDeal,
  queryDealByColleagueId,
  selectStatistic,
  queryDealPursuitsByCustomerIdAndType,
  queryDealPursuitsByCustomerOwnerId,
  queryChargeOutDealByAccountId,
  queryForecastDealByAccountId,
  selectDealUserForecastProportion,
  updateDealUserForecastProportion,
  getLoginUserDeals,
  getDealCloseReason,
  getDealTeamUser,
}
